<div class="planning-panel ev-card" data-testid="planning-panel" data-tutorial-container="planning-panel"
  [class.map-card-open]="hiddenForMapCard()"
  [style.height.px]="mobileResolution() && selectedDisplayMode()==DisplayMode.ROUTE ? effectivePanelHeight() : null">

  <app-ev-loader label="" [hidden]="(routeData!=undefined && loadingMap!='line') || selectedDisplayMode() != DisplayMode.ROUTE || failedPlan() || noRoute()"></app-ev-loader>

  <div class="route-planned" [hidden]="(!routeData && !failedPlan() && !noRoute()) || (mobileResolution() && (routeData==undefined || loadingMap=='line') && selectedDisplayMode()==DisplayMode.ROUTE && !failedPlan() && !noRoute())">
    <div class="scrollable" [hidden]="mobileResolution() && mobileVisibleRoutePanel()!='routepoints' || selectedDisplayMode()!=DisplayMode.ROUTE">
      <app-planning-waypoints
        [navigation]="navigation()"
        [selectedDisplayMode]="selectedDisplayMode()"
        [routeList]="routeList()"
        [failedPlan]="failedPlan()"
        [maxReachedWaypoint]="maxReachedWaypoint()"
        [mobileResolution]="mobileResolution() ?? false"
        [mobileVisibleRoutePanel]="mobileVisibleRoutePanel()"
        [emptySearchInput]="emptySearchInput()"
        [isAuthorized]="isAuthorized()"
        (requestOpenAccount)="openAccount()"
        (requestOpenSettings)="openSettings()"
        (requestOpenGpsError)="openGpsErrorDialog()"
        (searchActiveChanged)="waypointSearchActiveHandler($event)">
      </app-planning-waypoints>

    <div class="planning-panel-scrollbar-wrapper scroll-active-width" [hidden]="failedPlan()"
      [ngClass]="{'infopanel': mobileVisibleRoutePanel()=='info' }">

      <!-- Track information -->
      <app-track-information
        [class.infopanel]="mobileVisibleRoutePanel()=='info'"
        [routeData]="routeData"
        [failedPlan]="failedPlan()"
        [noRoute]="noRoute()"
        [loadingMap]="loadingMap ?? ''">
      </app-track-information>

      <!-- Route plan -->
      <app-route-plan
        [routeData]="routeData"
        [loadingMap]="loadingMap ?? ''"
        [noRoute]="noRoute()"
        [activePlanningPanelRouteElement]="activePlanningPanelRouteElement() ?? -1"
        (routePlanClick)="openRoutePlanPoint($event.routeEl, $event.index)">
      </app-route-plan>

      <!-- Itinerary -->
      <app-itinerary
        [routeData]="routeData"
        [loadingMap]="loadingMap ?? ''"
        [noRoute]="noRoute()"
        [itineraryNextTurnIdx]="itineraryNextTurnIdx()"
        [navigation]="navigation()"
        (turnClick)="navigateToTurn($event)">
      </app-itinerary>
    </div>

    @if ((failedPlan() || noRoute()) && !navigation() && selectedDisplayMode()==DisplayMode.ROUTE) {
    <div class="route-empty-state" data-testid="route-empty-state">

    <!-- Broken route: the line from the current position never reaches the destination pin -->
    <svg class="route-empty-art" viewBox="0 0 240 150" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <defs>
        <linearGradient id="routeEmptyStroke" x1="30" y1="120" x2="200" y2="50" gradientUnits="userSpaceOnUse">
          <stop class="route-empty-stop-1" offset="0"/>
          <stop class="route-empty-stop-2" offset="1"/>
        </linearGradient>
        <radialGradient id="routeEmptyGlow" cx="0.5" cy="0.5" r="0.5">
          <stop class="route-empty-glow-in" offset="0"/>
          <stop class="route-empty-glow-out" offset="1"/>
        </radialGradient>
      </defs>

      <ellipse class="route-empty-glow" cx="120" cy="76" rx="110" ry="62"/>

      <!-- Planned leg: solid, brand coloured, stops dead at the barrier -->
      <path class="route-empty-path" d="M40 110 C70 110 84 74 104 71.5"/>

      <!-- Unreachable leg: dotted trail running into the destination -->
      <path class="route-empty-path-ghost" d="M139 70 C160 68 178 72 194 72"/>

      <!-- Current position marker -->
      <circle class="route-empty-origin-ring" cx="40" cy="110" r="10"/>
      <circle class="route-empty-origin-dot" cx="40" cy="110" r="4.5"/>

      <!-- Destination pin, greyed out: it cannot be reached -->
      <path class="route-empty-pin" d="M194 33 C186.8 33 181 38.8 181 46 C181 55 194 72 194 72 C194 72 207 55 207 46 C207 38.8 201.2 33 194 33 Z"/>
      <circle class="route-empty-pin-core" cx="194" cy="46" r="4.5"/>

      <!-- No-entry roundel sitting in the gap -->
      <circle class="route-empty-badge-halo" cx="122" cy="70" r="17"/>
      <circle class="route-empty-badge" cx="122" cy="70" r="17"/>
      <rect class="route-empty-badge-bar" x="112" y="67.25" width="20" height="5.5" rx="2.75"/>
    </svg>

    <h4 class="route-empty-title">
      {{ failedPlan() ? languageService.languageJSON.InfoSidebar_Routing_Failed
                      : languageService.languageJSON.InfoSidebar_NoRoute_Title }}
    </h4>
    <p class="route-empty-text">
      {{ failedPlan() ? languageService.languageJSON.InfoSidebar_Routing_Failed_Description
                      : languageService.languageJSON.InfoSidebar_NoRoute_Description }}
    </p>
    </div>
    }
  </div>

</div>

@if (selectedDisplayMode()==DisplayMode.ROUTE && !navigation()) {
<div class="navigation-menu-outer">
  <app-navigation-menu [failedPlan]="failedPlan()" [noRoute]="noRoute()" [loadingMap]="loadingMap!=null">
  </app-navigation-menu>
</div>
}

<div class="pane-drag-outer" data-testid="planning-panel-drag-container" #paneDragOuter>
  <div class="pane-drag-element"></div>
</div>
</div>